import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';

export function useUser() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    // 현재 로그인 유저 정보 가져오기
    supabase.auth.getUser().then(({ data, error }) => {
      if (data?.user) setUser(data.user);
      else setUser(null);
    });

    // 인증 상태 변경 감지(로그인/로그아웃 등)
    const { data: listener } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null);
    });

    return () => {
      listener?.subscription.unsubscribe();
    };
  }, []);

  return { user };
}
